import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import "../styles/control-buttons.css";

export interface ControlBtnProps {
  Label: string;
  onClick: any;
  tooltip: string;
  customStyle: string;
}

export const ControlButton = (props: ControlBtnProps) => {
  return (
    <>
      <button
        data-tooltip-id={"tooltip-id-" + props.tooltip}
        data-tooltip-float={true}
        data-tooltip-content={props.tooltip}
        onClick={() => props.onClick()}
        className={
          "shadow-sm bg-gray-50 bg-opacity-100 rounded-sm mt-3 border-black border w-10 h-10 control-button " +
          props.customStyle
        }
      >
        <i className={"fa-lg fa fa-" + props.Label}></i>
      </button>

      <Tooltip id={"tooltip-id-" + props.tooltip} place="left" />
    </>
  );
};
